import {Badge} from 'react-bootstrap'

const COLORS = {
  ACTIVE: 'active',
  SIGNED: 'success',
  PENDING: 'warning',
}

export const BadgeStatus = ({state}: {state: string}) => {
  return <Badge bg={COLORS[state]}>{state}</Badge>
}
